module.exports = __webpack_public_path__ + "img/proyek-icon.e8fd0f0d.svg";